<template>
    <div class="config-wrapper">
        <div class="config-content">
            <header class="config-head">
                <p class="config-title">{{ $t("cookie_consent.cookies_manage_preferences") }}</p>
                <button class="close" aria-label="close" @click="$emit('close')"></button>
            </header>
            <section class="config-body">
                <div class="choice">
                    <div class="choice-title">{{ cookies.group1.title }}</div>
                    <div class="choice-switch">
                        <input id="switch1" type="checkbox" class="checkbox" disabled="disabled" checked="checked" />
                        <label for="switch1" class="switch disabled"></label>
                    </div>
                    <div class="choice-text">{{ cookies.group1.text }}</div>
                </div>
                <div class="choice">
                    <div class="choice-title">{{ cookies.group2.title }}</div>
                    <div class="choice-switch">
                        <input id="switch2" v-model="statsChoice" type="checkbox" class="checkbox" value="true" />
                        <label for="switch2" class="switch"></label>
                    </div>
                    <div class="choice-text">{{ cookies.group2.text }}</div>
                </div>
                <div class="choice">
                    <div class="choice-title">{{ cookies.group3.title }}</div>
                    <div class="choice-switch">
                        <input id="switch3" v-model="otherChoice" type="checkbox" class="checkbox" value="true" />
                        <label for="switch3" class="switch"></label>
                    </div>
                    <div class="choice-text">{{ cookies.group3.text }}</div>
                </div>
                <!--<span>Checked Groups: {{ statsChoice }} {{ otherChoice }}</span>-->
            </section>
            <footer class="config-footer">
                <button class="button-std" @click="sendChoice({ statistics: statsChoice, other: otherChoice })">
                    {{ $t("cookie_consent.cookies_confirm_choice") }}
                </button>
                <button class="button-cta" @click="sendChoice({ statistics: true, other: true })">
                    {{ $t("cookie_consent.cookies_accept_all") }}
                </button>
            </footer>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        statistics: {
            type: Boolean,
            default: false
        },
        other: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            statsChoice: this.statistics,
            otherChoice: this.other,
            cookies: {
                group1: {
                    title: this.$t("cookie_consent.cookies_functional_title"),
                    text: this.$t("cookie_consent.cookies_functional_text")
                },
                group2: {
                    title: this.$t("cookie_consent.cookies_analytical_title"),
                    text: this.$t("cookie_consent.cookies_analytical_text")
                },
                group3: {
                    title: this.$t("cookie_consent.cookies_marketing_title"),
                    text: this.$t("cookie_consent.cookies_marketing_text")
                }
            }
        };
    },
    methods: {
        sendEvent(value) {
            console.log("sendEvent", value);
            this.$emit("child-events", value);
        },
        sendChoice(values) {
            console.log("save Choice aus config", { statistics: values.statistics, other: values.other });
            this.$emit("save-choice", { statistics: values.statistics, other: values.other });
        }
    }
};
</script>

<style scoped>
.config-wrapper {
    z-index: 5;
    position: fixed;
    top: 0px;
    width: 100%;
    height: 100%;
    background-color: rgba(10, 10, 10, 0.625);
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    overflow: hidden;
}
.config-content {
    display: flex;
    flex-direction: column;
    max-width: 800px;
    width: 95%;
    margin: 0 auto;
    max-height: calc(100vh - 120px);
    overflow: auto;
}

.config-content > * {
    min-width: 300px;
}

.config-head {
    position: relative;
    padding: 0.875rem;
    background-color: #fff;
    border-top-left-radius: 6px;
    border-top-right-radius: 6px;
    display: flex;
    flex-shrink: 0;
    justify-content: space-between;
    align-items: center;
}

@media screen and (min-width: 768px) {
    .config-head {
        padding: 1.25rem;
    }
}

.config-title {
    color: var(--color-primary, #0096db);
}
.close {
    padding: 1px 6px;
    -webkit-touch-callout: none;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    -moz-appearance: none;
    -webkit-appearance: none;
    background-color: rgba(10, 10, 10, 0.2);
    border: none;
    border-radius: 10px;
    cursor: pointer;
    pointer-events: auto;
    display: inline-block;
    flex-grow: 0;
    flex-shrink: 0;
    font-size: 0;
    height: 20px;
    width: 20px;
    outline: none;
    position: relative;
    vertical-align: top;
}

.close::before,
.close::after {
    height: 2px;
    width: 50%;
    background-color: #fff;
    content: "";
    display: block;
    left: 50%;
    position: absolute;
    top: 50%;
}
.close::before {
    transform: translateX(-50%) translateY(-50%) rotate(45deg);
    transform-origin: center center;
}
.close::after {
    transform: translateX(-50%) translateY(-50%) rotate(-45deg);
    transform-origin: center center;
}

.config-body {
    flex: 1 1 auto;
    overflow-y: auto;
    min-height: 100px;
    background-color: #f2f2f2;
    padding: 0.875rem;
}

@media (min-width: 768px) {
    .config-body {
        padding: 1rem;
    }
}

.choice {
    display: grid;
    column-gap: 0.875rem;
    grid-template-columns: 4fr 1fr;
    grid-template-areas:
        "titel switch"
        "text text";
    overflow: auto;
}

@media (min-width: 768px) {
    .choice {
        column-gap: 1rem;
    }
}

.choice:not(:last-child) {
    padding-bottom: 0.875rem;
}

@media (min-width: 768px) {
    .choice:not(:last-child) {
        padding-bottom: 1rem;
    }
}

.choice-title {
    grid-area: titel;
    font-size: 1rem;
    font-weight: 700;
    color: #424242;
}

.choice-switch {
    grid-area: switch;
    justify-self: end;
}

.choice-text {
    grid-area: text;
    color: #424242;
    max-width: 670px;
    font-size: 0.875rem;
}

@media (min-width: 768px) {
    .choice-text {
        font-size: 1rem;
    }
}

/* https://medium.com/front-end-weekly/creating-a-toggle-switch-in-css-2d23e496d035 */

.checkbox {
    display: none;
}

.switch {
    position: relative;
    display: inline-block;
    width: 40px;
    height: 20px;
    background-color: #dbdbdb;
    border-radius: 20px;
}

.switch:not(.disabled) {
    cursor: pointer;
}

.switch::after {
    content: "";
    position: absolute;
    width: 18px;
    height: 18px;
    border-radius: 50%;
    background-color: white;
    top: 1px;
    left: 1px;
    transition: all 0.5s;
}

.checkbox:checked + .switch::after {
    left: 20px;
}
.checkbox:checked + .switch {
    background-color: var(--color-primary, #0096db);
}

.checkbox:checked + .switch.disabled {
    background-color: var(--color-primary, #0096db);
    opacity: 0.4;
}

.config-footer {
    flex-shrink: 0;
    display: flex;
    flex-direction: column-reverse;
    background-color: #fff;
    padding: 0.875rem;
    border-bottom: 1px solid #dbdbdb;
    border-bottom-left-radius: 6px;
    border-bottom-right-radius: 6px;
}

@media (min-width: 480px) {
    .config-footer {
        flex-direction: row;
        justify-content: flex-end;
    }
}

@media (min-width: 768px) {
    .config-footer {
        padding: 1rem;
    }
}

.button-cta,
.button-std,
.button-as-link {
    margin-top: 0.5rem;
}

@media (min-width: 480px) {
    .button-cta {
        margin-left: 0.5rem;
    }
}
</style>
